import React from 'react'
import GameItemCard from './GameItemCard';
import { Stack } from '@mui/material';

const GameList = ({ gameData, onItemClick }) => {
    return (
        <Stack spacing={2}>
            {gameData?.map((item, index) => (
                <GameItemCard
                    key={index}
                    index={index}
                    item={item}
                    gameData={gameData}
                    onItemClick={onItemClick}
                />
            ))}
        </Stack>
    )
}

export default GameList;